module.exports = __webpack_public_path__ + "static/media/7.ee16c3e8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/magazine/7.jpg
// module id = 60
// module chunks = 0